export default {
  WithdrawRequest: "WithdrawRequest",
};
